import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useClienteAuth } from '../../contexts/ClienteAuthContext';
import { LogoMark } from '../../components/ui';
import { iniciais } from '../../lib/format';
import { LayoutGrid, Package, ShieldCheck, LogOut, Store, Plus } from 'lucide-react';

const abas = [
  { para: '/loja/conta', rotulo: 'Visão geral', icon: LayoutGrid, fim: true },
  { para: '/loja/conta/pedidos', rotulo: 'Meus pedidos', icon: Package },
  { para: '/loja/conta/seguranca', rotulo: 'Conta e segurança', icon: ShieldCheck },
];

export function ContaLayout() {
  const { cliente, logout } = useClienteAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-ink-50">
      {/* Header */}
      <header className="bg-white border-b border-ink-100 sticky top-0 z-40">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
          <Link to="/loja" className="flex items-center gap-2.5 shrink-0">
            <LogoMark size={30} />
            <span className="font-display font-bold text-ink-950 tracking-tight hidden sm:inline">MONCHERY</span>
          </Link>

          <div className="flex items-center gap-2 sm:gap-3">
            <button
              onClick={() => navigate('/loja')}
              className="btn-primary !rounded-full !px-4 !py-2 !text-[13px]"
            >
              <Plus className="w-4 h-4" />
              <span className="hidden sm:inline">Novo pedido</span>
            </button>
            <Link
              to="/loja"
              className="hidden md:inline-flex items-center gap-1.5 text-[13px] font-semibold text-ink-500 hover:text-ink-800 transition-colors"
            >
              <Store className="w-4 h-4" /> Loja
            </Link>
            <div className="flex items-center gap-2.5 pl-2 sm:pl-3 border-l border-ink-200">
              <div className="w-8 h-8 rounded-full bg-brand-600 text-white text-xs font-bold flex items-center justify-center shrink-0">
                {iniciais(cliente?.nome)}
              </div>
              <div className="hidden sm:block leading-tight">
                <p className="text-[13px] font-semibold text-ink-900 max-w-[140px] truncate">{cliente?.nome}</p>
                <p className="text-2xs text-ink-400 max-w-[140px] truncate">{cliente?.email}</p>
              </div>
              <button onClick={logout} className="icon-btn" title="Sair" aria-label="Sair">
                <LogOut className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>

        {/* Abas */}
        <nav className="max-w-5xl mx-auto px-4 sm:px-6 flex gap-1 overflow-x-auto">
          {abas.map(({ para, rotulo, icon: Icon, fim }) => (
            <NavLink
              key={para}
              to={para}
              end={fim}
              className={({ isActive }) =>
                `flex items-center gap-2 px-3.5 py-2.5 text-[13px] font-semibold border-b-2 -mb-px whitespace-nowrap transition-colors ${
                  isActive
                    ? 'border-brand-600 text-brand-700'
                    : 'border-transparent text-ink-500 hover:text-ink-800'
                }`
              }
            >
              <Icon className="w-4 h-4" />
              {rotulo}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
}
